import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import type { LegalDocumentsActions } from './types/actions.types';
import LegalDocumentsRecord from './data/LegalDocumentsRecord';
import LegalDocumentsContainerConstants from './constants';

function getInitialState() {
  return new LegalDocumentsRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<LegalDocumentsRecord, LegalDocumentsActions> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case LegalDocumentsContainerConstants.GET_LEGAL_DOCUMENTS_REQUEST:
      return state.merge({
        isLoading: true,
        error: undefined,
      });

    case LegalDocumentsContainerConstants.GET_LEGAL_DOCUMENTS_REQUEST_SUCCESS: {
      const {
        imprint,
        privacyNotice,
        cookiePolicy,
        dataProcessing,
        paymentTerms,
        termsAndConditions,
        personalInformationSharingPolicies,
      } = action.response;
      return state
        .merge({ isLoading: false })
        .setDocuments(
          imprint,
          privacyNotice,
          termsAndConditions,
          cookiePolicy,
          paymentTerms,
          dataProcessing,
          personalInformationSharingPolicies
        );
    }

    case LegalDocumentsContainerConstants.GET_LEGAL_DOCUMENTS_REQUEST_ERROR:
      return state.merge({
        isLoading: false,
        error: new ErrorRecord(action.error),
      });

    default:
      return state;
  }
};

export default reducer;
